export enum HeadStart {
  HeadStartGrantee = 1,
  HeadStartDelegate = 2,
}
